import {
    Button,
    IconButton,
    makeStyles,
    Modal,
    Paper, Snackbar,
    Typography
} from "@material-ui/core";
import React, { useContext, useState } from "react";
import { Close } from "@material-ui/icons";
import AppState from '../../context/AppContext';

const useStyles = makeStyles((theme) => ({
    input: {
        minWidth: '360px',
        backgroundColor: 'white',
        color: 'black',
        '& .MuiFormHelperText-root': {
            color: 'black',
        },
        '& .Mui-error': {
            color: 'black',
        },
    },
    errorText: {
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    card: {
        marginTop: '20px',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        margin: 'auto',
        maxWidth: '420px',
        padding: theme.spacing(2),
    },
    typography: {
        marginTop: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardModal: {
        width: '100%',
    },
    closeButton: {
        float: 'right'
    },
}));

const EditChild = ( props ) => {
    const classes = useStyles();
    const [openSnack, setOpenSnack] = useState(false)
    const auth = JSON.parse( sessionStorage.getItem( "user" ) );
    const context = useContext( AppState );
    const handleClose = () => {
        props.handleClose();
    };
    const onSubmit = ( values ) => {
        const index = context.store.children.findIndex(
            ( child ) => child.uid === props.uid
        );
        context.store.children.splice(index, 1);
        context.deleteChildDB( auth.user._id, props.uid ).then( ( data ) => {
            if(data){
                setOpenSnack(true)
            }
        } );
    };
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        context.store.addDelete = false
        context.setStore( {
            ...context.store,
        } );
    };
    return (
        <Modal open={props.open} className={classes.modal}>
            <Paper className={classes.paper}>
                <IconButton className={classes.closeButton} onClick={handleClose}>
                    <Close />
                </IconButton>
                <Typography variant="h5">Delete Child</Typography>
                <Typography className={classes.typography}>
                    Are you sure you want to delete this child?
                </Typography>
                <Button variant="contained" color="primary" onClick={onSubmit}>
                    Confirm
                </Button>
                <Button variant="contained" color="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={openSnack}
                    autoHideDuration={2000}
                    onClose={handleSnackbarClose}
                    message={`${context.store.currentChildName} successfully deleted!`}
                    action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackbarClose}>
                            <Close fontSize="small" />
                        </IconButton>
                    }
                />
            </Paper>
        </Modal>
    );
};

export default EditChild;
